
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SimpleAuthChecker } from "../auth/SimpleAuthChecker";
import AppRoutes from "../routing/AppRoutes";
import FixedElements from "./FixedElements";

const AppLayout: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('[AppLayout] Current route:', location.pathname);
    
    // Ensure visibility
    document.body.style.display = 'block';
    document.body.style.visibility = 'visible';
    document.body.style.opacity = '1';
    document.body.style.backgroundColor = '#ffffff';

    // Add body classes for styling hooks
    document.body.classList.add('has-bottom-nav', 'has-fab');

    // Create isolated stacking context for fixed elements
    document.body.style.isolation = 'isolate';
    document.body.style.position = 'relative';
  }, [location.pathname]);

  return (
    <>
      <div 
        data-testid="app-content" 
        style={{
          display: 'block',
          visibility: 'visible',
          opacity: 1,
          minHeight: '100vh',
          width: '100%',
          backgroundColor: '#ffffff',
          position: 'relative',
          zIndex: 1
        }}
      >
        <SimpleAuthChecker>
          <AppRoutes />
        </SimpleAuthChecker>
      </div>
      
      {/* Fixed elements rendered via portals outside any containers */}
      <FixedElements />
    </>
  );
};

export default AppLayout;
